import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

const IncomingCashsOtherPaymentDetail = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return (
    <>
    </>
  );
};

export default IncomingCashsOtherPaymentDetail;
